
import React, { useState, startTransition } from 'react';
import { TwilioDialer } from '@/components/dialer/TwilioDialer';
import { CallStatusSection } from './CallStatusSection';
import { DialerSidebar } from './DialerSidebar';
import { useTwilioContext } from '@/context/TwilioContext';

export const DialerMainContent = () => {
  console.log('🔍 DialerMainContent component rendering');
  
  const [activeRightTab, setActiveRightTab] = useState('analytics');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  const { callInProgress } = useTwilioContext();
  console.log('🔍 DialerMainContent - callInProgress:', callInProgress);

  const handleCloseDialer = () => {
    console.log('Dialer close requested - resetting state');
  };

  const handleTabChange = (tab: string) => {
    startTransition(() => {
      setActiveRightTab(tab);
    });
  };

  const handleMobileMenuChange = (open: boolean) => {
    startTransition(() => {
      setIsMobileMenuOpen(open);
    });
  };

  return (
    <div className="flex-1 flex overflow-hidden">
      {/* Left Panel - Dialer */}
      <div className={`${callInProgress ? 'hidden md:flex' : 'flex'} w-full md:w-80 bg-background flex-col`}>
        <TwilioDialer 
          onClose={handleCloseDialer} 
          fullscreen={false}
          showHeader={false}
        />
      </div>

      {/* Center Panel - Call Status & Transcript */}
      <div className="flex-1 flex flex-col min-w-0">
        <CallStatusSection />
      </div>

      {/* Right Panel - Analytics & Tools */}
      <DialerSidebar 
        activeTab={activeRightTab}
        onTabChange={handleTabChange}
        isMobileMenuOpen={isMobileMenuOpen}
        onMobileMenuChange={handleMobileMenuChange}
      />
    </div>
  );
};
